
import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, Tabs, Tab } from '@material-ui/core';
import MBackIcon from '../view/MBackIcon';
import MStatusBar from '../view/MStatusBar';
import TabIndicator from '../view/TabIndicator';

class MatchLeagueHeader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: 0,
        };
    }

    _handleChange(val) {
        this.setState({ value: val });
        this.props.onChange && this.props.onChange(val);
    }

    render() {
        const { value } = this.state;
        return (
            <Grid container direction='column' alignItems='center' style={{ boxShadow: '1px 1px 3px #F0F0F0' }}>
                <MStatusBar />
                <Grid container direction='row' alignItems='center' >
                    <MBackIcon />
                    <Grid container direction='row' justify='center' alignItems='center'>
                        <Tabs
                            value={value}
                            onChange={(e, val) => this._handleChange(val)}
                            TabIndicatorProps={{ children: <TabIndicator />, style: { backgroundColor: 'transparent', marginBottom: 1.5 } }}
                        >
                            <Tab label='足球数据' style={{ color: '#0D0D0D', opacity: 1, fontSize: value == 0 ? 17 : 14, fontWeight: value == 0 ? 'bold' : 'inherit' }}></Tab>
                            <Tab label='篮球数据' style={{ color: '#0D0D0D', opacity: 1, fontSize: value == 1 ? 17 : 14, fontWeight: value == 1 ? 'bold' : 'inherit' }}></Tab>
                        </Tabs>
                    </Grid>
                </Grid>
            </Grid >
        );
    }

}

export default withRouter(withStyles((theme) => ({

}))(MatchLeagueHeader));